// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3WmKx","rootCenter":"LoadMoreObserver_rootCenter__Fj67t","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__HW02b"};